<template>
    <div class="horizontal-scrollbar" ref="rootEl">
        <swiper v-bind="swiperOptions" @swiper="setSwiperRef">
            <slot name="slides" />
        </swiper>
        <div class="horizontal-scrollbar-nav">
            <button type="button" class="btn btn-icon swiper-button swiper-button-prev" :class="'horizontal-scrollbar--prev-' + uid">
                <slot name="nav-icon"/>
                <span class="visually-hidden">Previous slide</span>
            </button>
            <button type="button" class="btn btn-icon swiper-button swiper-button-next" :class="'horizontal-scrollbar--next-' + uid">
                <slot name="nav-icon"/>
                <span class="visually-hidden">Next slide</span>
            </button>
        </div>
    </div>
</template>

<script>
// import Swiper core and required modules
import SwiperCore, { Navigation } from 'swiper';

import { Swiper } from 'swiper/vue';

SwiperCore.use([Navigation]);

export default {
    components: {
        'swiper': Swiper
    },
    props: {
        uid: {
            type: Number,
            default: 0,
        },
        centerItems: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            swiperRef: null,
            isInitialSlidePerformed: false,
            swiperOptions: {
                speed: 500,
                threshold: 10,
                watchOverflow: true,
                followFinger: true,
                slidesPerView: 'auto',
                freeMode: true,
                centerInsufficientSlides: this.centerItems,
                navigation: {
                    prevEl: `.horizontal-scrollbar--prev-${this.uid}`,
                    nextEl: `.horizontal-scrollbar--next-${this.uid}`,
                },

            },
        };
    },
    provide() {
        return {
            updateHorizontalScrollSwiper: this.updateHorizontalScrollSwiper,
        };
    },
    mounted() {
        this.$root.lazyLoad.update();
    },
    methods: {
        setSwiperRef(swiper) {
            this.swiperRef = swiper;
        },
        updateHorizontalScrollSwiper() {
            if (this.swiperRef) {
                this.swiperRef.update();

                if (!this.isInitialSlidePerformed) {
                    this.slideToInitial();
                }
            }
        },
        slideToInitial() {
            const activeItem = this.swiperRef.el.querySelector('.swiper-slide > .active');

            if (activeItem) {
                const activeSlideIndex = this.swiperRef.slides.indexOf(activeItem.parentElement);

                if (activeSlideIndex > 0) {
                    this.slideTo(activeSlideIndex);
                }

                this.isInitialSlidePerformed = true
            }
        },
        slideTo(index, speed = 0) {
            if (this.swiperRef) {
                this.swiperRef.slideTo(index, speed);
            }
        },
    }
};
</script>
